import { render, staticRenderFns } from "./IconTrash24.vue?vue&type=template&id=0d45a3ee&"
import script from "./IconTrash24.vue?vue&type=script&lang=ts&"
export * from "./IconTrash24.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports